"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _react.default.createElement("svg", {
  width: "12",
  height: "16",
  viewBox: "0 0 12 16"
}, _react.default.createElement("path", {
  fillRule: "evenodd",
  d: "M8.73 1.39A1.06 1.06 0 007.72 0H3.43c-.45 0-.9.32-1.12.75L.05 8.2c-.22.75.34 1.4 1.02 1.4h4.17l-1.12 5.75c-.12.56.63.88 1 .43l6.65-8.75c.57-.64 0-1.7-.9-1.7H7.5l1.24-3.95zm-3.27 12.3L11 6.42a.17.17 0 00-.06-.07.1.1 0 00-.06-.02H6.13L7.77 1.1l.01-.05v-.01A.07.07 0 007.71 1H3.43s-.03 0-.09.04a.5.5 0 00-.11.12L1 8.5V8.57c.01.02.03.03.06.03h5.38l-.99 5.09z"
}));

exports.default = _default;